<template>
    <section id="wrapper" class="auth-saas auth-saas--pro">
        <div class="auth-saas__layout auth-saas__layout--centered">
            <div class="auth-saas__form-column">
                <div class="auth-saas__form-inner">
                    <div class="auth-saas__card">
                        <div class="auth-saas__user">
                            <img :src="getAuthUser('avatar')" class="auth-saas__avatar" width="72" height="72" alt="">
                            <p class="auth-saas__user-name">{{ getAuthUser('full_name') }}</p>
                        </div>
                        <div class="text-center mb-2">
                            <span class="auth-saas__eyebrow">Screen locked</span>
                        </div>
                        <h1 class="auth-saas__title text-center">{{ trans('auth.password') }}</h1>
                        <p class="auth-saas__subtitle text-center">Enter your password to unlock the admin panel and continue where you left off.</p>
                        <div class="auth-saas__mini-chip">
                            <span class="auth-saas__status-chip-dot" aria-hidden="true"></span>
                            <span>Session locked</span>
                            <kbd>Verify</kbd>
                        </div>
                        <form class="form-validate is-alter" id="lockScreenForm" @submit.prevent="submit" @keydown="lockScreenForm.errors.clear($event.target.name)">
                            <div class="form-group">
                                <label class="auth-saas__label" for="lock-password">{{ trans('auth.password') }}</label>
                                <div class="auth-saas__input-wrap">
                                    <admin-icon name="lock" aria-hidden="true"></admin-icon>
                                    <input id="lock-password" type="password" name="password" class="auth-saas__input" autocomplete="current-password" :placeholder="trans('auth.password')" v-model="lockScreenForm.password">
                                </div>
                                <show-error :form-name="lockScreenForm" prop-name="password" class="text-danger"></show-error>
                            </div>
                            <div class="form-group mb-0">
                                <button class="auth-saas__btn" type="submit" :disabled="lockScreenForm.busy">
                                    <span v-if="lockScreenForm.busy" class="auth-saas__btn-spinner" aria-hidden="true"></span>
                                    <admin-icon name="arrow-right" v-else aria-hidden="true"></admin-icon>
                                    <span>{{ trans('auth.confirm') }}</span>
                                </button>
                            </div>
                        </form>
                        <div class="auth-saas__note">
                            <a href="#" class="auth-saas__link-muted" @click.prevent="logout"><admin-icon name="logout"></admin-icon> {{ trans('auth.logout') }}</a>
                        </div>
                    </div>
                </div>
                <div class="auth-saas__footer">
                    <guest-footer></guest-footer>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import guestFooter from '../../layouts/guest-footer.vue'

    export default {
        components: {guestFooter},
        data(){
            return {
                lockScreenForm: new Form({
                    password: '',
                })
            }
        },
        mounted(){
            if(!helper.getConfig('lock_screen') || !helper.isScreenLocked())
                this.$router.push('/home');
        },
        methods: {
            logout(){
                helper.logout().then(() => {
                    this.$store.dispatch('resetAuthUserDetail');
                    this.$router.push('/login')
                })
            },
            submit(){
                this.lockScreenForm.post('/api/auth/lock')
                    .then(response => {
                        this.$store.dispatch('setLastActivity');
                        toastr.success(response.message);
                        this.$router.push('/home');
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getAuthUser(name){
                return helper.getAuthUser(name);
            }
        },
        computed: {
        }
    }
</script>
